import { TApplicationState } from '../../types/redux';

export const getUrlPath = (state: TApplicationState) => {
  return state.path || null;
};
